import { c as _c } from "react/compiler-runtime";
import { EMAIL_STATISTICS_API } from 'modules/email-statistics/api/email-statistics-api';
import { EmailStatisticsFilterInterface, EmailStatisticsTableApiInterface } from 'modules/email-statistics/types/email-statistics-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
interface UseEmailStatisticTableInterface extends SwrPaginationInterface {
  filter: EmailStatisticsFilterInterface;
}
export const useEmailStatisticsTable = t0 => {
  const $ = _c(7);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.dateSince !== null ? `&filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== limit || $[3] !== pagination) {
    t2 = () => [`${EMAIL_STATISTICS_API}/list?${getPaginationQueryString({
      limit,
      pagination
    })}${filterApi}`, RequestModuleEnum.CampaignStep];
    $[1] = filterApi;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: emailDashboardTable
  } = useControlledSwr(t2, fetcher, undefined, !!user && filter.dateTill !== null);
  let t3;
  if ($[5] !== emailDashboardTable) {
    t3 = {
      emailDashboardTable
    };
    $[5] = emailDashboardTable;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};